// var EventType = require('../../constants/event-type.js');
// var ChartUtil = require('../dashboard/dashboard-widgets/line-bar-chart/chart-util.js');
// var ChartContainer = require('./chart-container.jsx');
// var Spreadsheet = require('./spreadsheet/spreadsheet.jsx');
import BaseComponent from "../../baseComponent.js";
import Spreadsheet from "../spreadsheet/spreadsheet.jsx";
import ChartContainer from "./chart/chartContainer.jsx";
import ChartUtil from "../../dashboard/widgets/timeseries-chart/chart-util.js";

export default class Content extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentWillUnmount() {
    $(window).off("resize");
  }

  handleResizeChart() {
    var chartWidget = $("#code-chart-container div"),
      widgetId = chartWidget.attr("id");
    ChartUtil.resizeCharts(widgetId, chartWidget.height(), chartWidget.width());
  }

  resizeContainer() {
    $("#content-container").height($(window).height() - $("#app-bar").height() - $("#studio-header").height());
    var newContainerHeight = $("#content-container").height();

    if (newContainerHeight > $(window).height()) debugger;

    if (this.prevContainerHeight !== undefined) {
      var diff = newContainerHeight - this.prevContainerHeight;
      if ($("div.resizable2").height() + diff < 100) {
        $("div.resizable1").height($("div.resizable1").height() + diff);
      } else {
        $("div.resizable1").height($("div.resizable1").height() + diff / 2);
        $("div.resizable2").height($("div.resizable2").height() + diff / 2);
      }
    }
    this.handleResizeChart();
    $(".resizable1").resizable("option", "maxHeight", $("#content-container").height() - 100);
    this.prevContainerHeight = newContainerHeight;
  }

  resizeButtomDiv(remainingSpace) {
    var newHeight = $("#content-container").height() - $("#code-chart-container").height();
    $("div.resizable2").height(newHeight);
  }

  componentDidMount() {
    var that = this,
      bottomDivMinHeight = 100,
      navbarHeight = $("header div.navbar").outerHeight(),
      headerHeight = $("div.studio-header").outerHeight(),
      maxHeight = $(window).height() - navbarHeight - headerHeight - bottomDivMinHeight;
    //var maxHeight = $(window).height() - 120 - 100;
    var handleResizeChart = this.handleResizeChart;
    $(".resizable1").resizable({
      autoHide: false,
      handles: 's',
      minHeight: 150,
      maxHeight: maxHeight,
      resize(e, ui) {
        var parentHeight = ui.element.parent().height();
        var remainingSpace = parentHeight - ui.element.outerHeight();
        var divTwo = ui.element.next();
        divTwo.height(remainingSpace);
        handleResizeChart();
        //that.resizeButtomDiv(remainingSpace);
      },
      stop() {
        Bullet.trigger(EventType.Studio.CONTAINER_RESIZED);
      }
    });
    $(window).resize(this.resizeContainer);
    this.resizeContainer();

  }

  render() {
    var style = {
      overflow: "hidden"
    };
    return (
      <div id="content-container">
        <div className="full-height" style={style}>
          <ChartContainer studioId={this.props.studioId} model={this.props.studio}/>
          <div className="resizable resizable2">
            <Spreadsheet model={this.props.studio}/>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/analytic-studio/editor/content.jsx